var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Packing Manager
 */
import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { message, Modal } from 'antd';
import { PrinterOutlined, ReloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';
import { usePackingState, usePackingActions, useLabelPrinting, useShipmentData, usePackageManagement, usePrinterConnection, useContainerActions, useAutoCompleteShipment } from '../hooks';
import { selectSpsCartonLabel, selectShipmentData, selectPackageContentBySeqId, selectContainerPackerBySeqId, selectContainerSerialNumbersByContainerId, selectShipmentItemSourceList } from '../../../redux/packing';
import { packItem, fetchShipmentDetails } from '../../../redux/packing/packingThunks';
import { containerScan } from '../../../redux/packing/containerThunks';
import { setScanQueueStatus } from '../../../redux/packing/packingSlice';
import { configureScanQueue, enqueueScan, flushScanQueueNow, clearScanQueue, getQueuedQuantityForProduct } from '../../../redux/packing/scanQueue';
import { UpdateAddressModal, PackCompleteModal, SerialNumberModal, UpdatePackageModal, CancelShipmentModal, PrinterModal, ReturnLabelModal, AutoCompleteCountdownModal, } from '../modals';
import { PackingSubscreen } from '../types';
import { ContainerStatus } from '../types/container.types';
import { StatusBadge, isPalletPackingAllowed, getPalletDisabledReason, useUserPartyId, decideContainerSwitch, boopScanRegistered, buzzScanError, chimeAssemblyProduced, ScanErrorStack, pushScanError, pushScanInfo, clearScanErrors, SoundToggleButton, AssemblyViewToggleButton } from '../shared';
import { PackingManagerActions } from './PackingManagerActions';
import { BulkPackModal } from '../modals/BulkPackModal';
import { BulkContainerModal } from '../modals/BulkContainerModal';
import { PackingPane } from './PackingPane';
import { ScanToPackView } from './ScanToPackView';
import { ContainerPane } from './ContainerPane';
import { ClosePackageModal } from '../modals/ClosePackageModal';
import { CloseContainerModal } from '../modals/CloseContainerModal';
import { UpdateContainerModal } from '../modals/UpdateContainerModal';
import { ItemsInAssemblySection } from './ItemsInAssemblySection';
import { LeftSidebar } from '../sidebar/LeftSidebar';
import { RightSidebar } from '../sidebar/RightSidebar';
export var PackingManager = function () {
    var _a, _b, _c, _d;
    var t = useTranslation().t;
    var bulkPackModalRef = useRef(null);
    var bulkContainerModalRef = useRef(null);
    var _e = useState(null), selectedPackageRef = _e[0], setSelectedPackageRef = _e[1];
    var _f = useState(null), selectedContainerRef = _f[0], setSelectedContainerRef = _f[1];
    var _g = useState(null), pendingContainerSwitch = _g[0], setPendingContainerSwitch = _g[1];
    var _h = useState([]), virtualPackages = _h[0], setVirtualPackages = _h[1];
    var _j = useState(null), pendingVirtualResolution = _j[0], setPendingVirtualResolution = _j[1];
    var _k = useState(false), isCloseModalVisible = _k[0], setIsCloseModalVisible = _k[1];
    var _l = useState(false), resettingPackage = _l[0], setResettingPackage = _l[1];
    var _m = useState(false), bulkPackModalVisible = _m[0], setBulkPackModalVisible = _m[1];
    var _o = useState(false), bulkContainerModalVisible = _o[0], setBulkContainerModalVisible = _o[1];
    var _p = useState(0), scanInputFocusSignal = _p[0], setScanInputFocusSignal = _p[1];
    var _q = usePackingState(), shipmentId = _q.shipmentId, shipmentStatus = _q.shipmentStatus, shipmentStatusList = _q.shipmentStatusList, shipmentPackages = _q.shipmentPackages, packageRouteSegments = _q.packageRouteSegments, shipmentRouteSegments = _q.shipmentRouteSegments, loading = _q.loading, boxTypes = _q.boxTypes, productSkuUpcList = _q.productSkuUpcList, shipmentItemDetailList = _q.shipmentItemDetailList, packageOrderItemsBySeqId = _q.packageOrderItemsBySeqId, kitComponentProducts = _q.kitComponentProducts, packageSerialNumbersBySeqId = _q.packageSerialNumbersBySeqId, itemAssets = _q.itemAssets, destContactMechValid = _q.destContactMechValid, scanThroughPack = _q.scanThroughPack, navigateToSubscreen = _q.navigateToSubscreen, clearShipment = _q.clearShipment, loadShipmentDetails = _q.loadShipmentDetails;
    var _r = usePackingState(), shipmentContainerList = _r.shipmentContainerList, containerLinkedPackageSeqIds = _r.containerLinkedPackageSeqIds, containerTypeList = _r.containerTypeList;
    var _s = useContainerActions(), handleContainerScan = _s.handleContainerScan, handleBulkCreateContainers = _s.handleBulkCreateContainers, handleCreateContainer = _s.handleCreateContainer, handleBulkCloseContainers = _s.handleBulkCloseContainers, handleReopenContainer = _s.handleReopenContainer, handleDeleteContainer = _s.handleDeleteContainer, handleResetContainer = _s.handleResetContainer, handleResetAndReturnContainer = _s.handleResetAndReturnContainer, handleUpdateContainerType = _s.handleUpdateContainerType;
    var _t = usePackingActions(), handleScanProduct = _t.handleScanProduct, handleUnpackItem = _t.handleUnpackItem, handleDeletePackage = _t.handleDeletePackage, handleUpdateQuantity = _t.handleUpdateQuantity, handleCancelShipment = _t.handleCancelShipment, handleResetAllPackages = _t.handleResetAllPackages, handleDeleteAllPackages = _t.handleDeleteAllPackages, handleGetMainLabel = _t.handleGetMainLabel, handleRefundLabel = _t.handleRefundLabel;
    var dispatch = useDispatch();
    var scanIdCache = useSelector(function (state) { return state.packing.scanIdCache; });
    var _u = useShipmentData(), findProductByIdOrSku = _u.findProductByIdOrSku, findKitProductByIdOrSku = _u.findKitProductByIdOrSku;
    var _v = useLabelPrinting(), printPackingSlip = _v.printPackingSlip, printContainerInsert = _v.printContainerInsert, printMainLabel = _v.printMainLabel, printCartonLabel = _v.printCartonLabel, printReturnLabel = _v.printReturnLabel, printContainerLabel = _v.printContainerLabel;
    var _w = usePackageManagement(), getPackageInfo = _w.getPackageInfo, resetPackage = _w.resetPackage;
    var isConnectionActive = usePrinterConnection().isConnectionActive;
    var confirm = Modal.confirm;
    // Auto-complete for DTC Shipments
    var autoComplete = useAutoCompleteShipment({
        onRequestScanFocus: function () { return setTimeout(function () { return setScanInputFocusSignal(function (prev) { return prev + 1; }); }, 0); }
    });
    var spsCartonLabel = useSelector(selectSpsCartonLabel);
    var containerPackerById = useSelector(selectContainerPackerBySeqId);
    var currentUserPartyId = useUserPartyId();
    var shipmentData = useSelector(selectShipmentData);
    var packageContentBySeqId = useSelector(selectPackageContentBySeqId);
    var containerSerialNumbersByContainerId = useSelector(selectContainerSerialNumbersByContainerId);
    var shipmentItemSourceList = useSelector(selectShipmentItemSourceList);
    // Some auditory feedback - Play a "too-tee-tee" (don't judge :)) sound when the assembly task turns components into a kit
    var prevAssemblyProducedRef = useRef(null);
    useEffect(function () {
        var previous = prevAssemblyProducedRef.current;
        var counts = new Map();
        ((shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.assemblyProducts) || []).forEach(function (product) {
            if (product === null || product === void 0 ? void 0 : product.productId)
                counts.set(product.productId, Number(product.completed || 0));
        });
        prevAssemblyProducedRef.current = { shipmentId: shipmentId, counts: counts };
        if (!previous || previous.shipmentId !== shipmentId)
            return;
        var producedEvents = 0;
        counts.forEach(function (count, productId) {
            var before = previous.counts.get(productId);
            if (before != null && count > before)
                producedEvents += 1;
        });
        if (producedEvents > 0)
            chimeAssemblyProduced(producedEvents);
    }, [shipmentData, shipmentId]);
    var _x = useState(false), printerModalVisible = _x[0], setPrinterModalVisible = _x[1];
    var _y = useState(false), addressModalVisible = _y[0], setAddressModalVisible = _y[1];
    var _z = useState(false), packCompleteModalVisible = _z[0], setPackCompleteModalVisible = _z[1];
    var _0 = useState(false), updatePackageModalVisible = _0[0], setUpdatePackageModalVisible = _0[1];
    var _1 = useState(false), cancelModalVisible = _1[0], setCancelModalVisible = _1[1];
    var _2 = useState(false), serialNumberModalVisible = _2[0], setSerialNumberModalVisible = _2[1];
    var _3 = useState(false), returnLabelModalVisible = _3[0], setReturnLabelModalVisible = _3[1];
    var _4 = useState(null), closeContainerModalContainerId = _4[0], setCloseContainerModalContainerId = _4[1];
    var _5 = useState(null), updateContainerModalContainerId = _5[0], setUpdateContainerModalContainerId = _5[1];
    var _6 = useState(null), pendingScanId = _6[0], setPendingScanId = _6[1];
    var _7 = useState(null), pendingSerializedPackRequest = _7[0], setPendingSerializedPackRequest = _7[1];
    var statusDescription = useMemo(function () { var _a; return (_a = shipmentStatusList.find(function (status) { return status.statusId === shipmentStatus; })) === null || _a === void 0 ? void 0 : _a.description; }, [shipmentStatusList, shipmentStatus]);
    var containerTypeMap = useMemo(function () {
        var map = new Map();
        containerTypeList.forEach(function (ct) { return map.set(ct.enumId, ct.description); });
        return map;
    }, [containerTypeList]);
    var selectedPackageSeqId = (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) === 'real' ? selectedPackageRef.seqId : null;
    var selectedPackageKey = selectedPackageRef
        ? selectedPackageRef.kind === 'real'
            ? "real:" + selectedPackageRef.seqId
            : "virtual:" + selectedPackageRef.tempId
        : null;
    var selectedContainerKey = selectedContainerRef
        ? "real:" + selectedContainerRef.containerId
        : null;
    var selectedRealContainerId = (_a = selectedContainerRef === null || selectedContainerRef === void 0 ? void 0 : selectedContainerRef.containerId) !== null && _a !== void 0 ? _a : null;
    // The linked package seqId for the currently selected container (if closed)
    var activeContainerLinkedSeqId = useMemo(function () {
        var _a;
        if (!selectedRealContainerId)
            return null;
        var container = shipmentContainerList.find(function (c) { return c.containerId === selectedRealContainerId; });
        return (_a = container === null || container === void 0 ? void 0 : container.shipmentPackageSeqId) !== null && _a !== void 0 ? _a : null;
    }, [selectedRealContainerId, shipmentContainerList]);
    // Container type for the selected container, used to constrain box-type
    // options in UpdatePackageModal when opened via the container pane.
    var activeContainerTypeEnumId = useMemo(function () {
        var _a;
        if (!selectedRealContainerId)
            return null;
        var container = shipmentContainerList.find(function (c) { return c.containerId === selectedRealContainerId; });
        return (_a = container === null || container === void 0 ? void 0 : container.containerTypeEnumId) !== null && _a !== void 0 ? _a : null;
    }, [selectedRealContainerId, shipmentContainerList]);
    var selectedVirtualPackage = (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) === 'virtual'
        ? virtualPackages.find(function (pkg) { return pkg.tempId === selectedPackageRef.tempId; })
        : undefined;
    var selectedPackageInfo = selectedPackageSeqId ? getPackageInfo(selectedPackageSeqId) : null;
    var selectedPackageRouteSegment = useMemo(function () {
        return selectedPackageSeqId
            ? packageRouteSegments.find(function (item) { return item.shipmentPackageSeqId === selectedPackageSeqId; }) ||
                null
            : null;
    }, [packageRouteSegments, selectedPackageSeqId]);
    var selectedPackageHasContents = useMemo(function () {
        return selectedPackageSeqId
            ? (packageContentBySeqId[selectedPackageSeqId] || []).length > 0
            : false;
    }, [packageContentBySeqId, selectedPackageSeqId]);
    var packageSeqIdsWithContent = useMemo(function () {
        return Object.entries(packageContentBySeqId)
            .filter(function (_a) {
            var contents = _a[1];
            return Array.isArray(contents) && contents.length > 0;
        })
            .map(function (_a) {
            var seqId = _a[0];
            return seqId;
        });
    }, [packageContentBySeqId]);
    var showResetAllPackages = useMemo(function () {
        if (!(packageRouteSegments === null || packageRouteSegments === void 0 ? void 0 : packageRouteSegments.length))
            return false;
        return packageSeqIdsWithContent.some(function (packageSeqId) {
            var packageRouteSegment = packageRouteSegments.find(function (item) { return item.shipmentPackageSeqId === packageSeqId; });
            return !(packageRouteSegment === null || packageRouteSegment === void 0 ? void 0 : packageRouteSegment.trackingCode);
        });
    }, [packageRouteSegments, packageSeqIdsWithContent]);
    var showDeleteAllPackages = ((packageRouteSegments === null || packageRouteSegments === void 0 ? void 0 : packageRouteSegments.length) || 0) > 0 && packageSeqIdsWithContent.length === 0;
    var materializeVirtualPackage = useCallback(function (tempId, shipmentPackageSeqId) {
        if (!shipmentPackageSeqId)
            return;
        setVirtualPackages(function (prev) { return prev.filter(function (pkg) { return pkg.tempId !== tempId; }); });
        setSelectedPackageRef(function (prev) {
            if ((prev === null || prev === void 0 ? void 0 : prev.kind) === 'virtual' && prev.tempId === tempId) {
                return { kind: 'real', seqId: shipmentPackageSeqId };
            }
            return prev;
        });
        setIsCloseModalVisible(false);
    }, []);
    var resolveShipmentPackageSeqIdFromScanResult = useCallback(function (scanResult) {
        if (!scanResult || typeof scanResult !== 'object') {
            return null;
        }
        var directSeqId = scanResult.shipmentPackageSeqId;
        if (typeof directSeqId === 'string' && directSeqId.trim()) {
            return directSeqId;
        }
        var packResult = scanResult.packResult;
        if (!packResult || typeof packResult !== 'object') {
            return null;
        }
        if (typeof packResult.shipmentPackageSeqId === 'string' &&
            packResult.shipmentPackageSeqId.trim()) {
            return packResult.shipmentPackageSeqId;
        }
        var shipmentPackage = packResult.shipmentPackage;
        if (shipmentPackage &&
            typeof shipmentPackage.shipmentPackageSeqId === 'string' &&
            shipmentPackage.shipmentPackageSeqId.trim()) {
            return shipmentPackage.shipmentPackageSeqId;
        }
        return null;
    }, []);
    var isSerializedScanId = useCallback(function (scanId) {
        if (!scanId)
            return false;
        var normalizedScanId = scanId.trim().toLowerCase();
        if (!normalizedScanId)
            return false;
        var matchedProduct = findProductByIdOrSku(scanId);
        if ((matchedProduct === null || matchedProduct === void 0 ? void 0 : matchedProduct.serialized) === 'Y') {
            return true;
        }
        var matchedByNormalizedSku = productSkuUpcList.find(function (item) {
            return [item.productId, item.productSku, item.productUpc]
                .filter(Boolean)
                .some(function (value) { return String(value).trim().toLowerCase() === normalizedScanId; });
        });
        if ((matchedByNormalizedSku === null || matchedByNormalizedSku === void 0 ? void 0 : matchedByNormalizedSku.serialized) === 'Y') {
            return true;
        }
        return (shipmentItemDetailList || []).some(function (item) {
            if ((item === null || item === void 0 ? void 0 : item.serialized) !== 'Y')
                return false;
            return [item.productId, item.pseudoId]
                .filter(Boolean)
                .some(function (value) { return String(value).trim().toLowerCase() === normalizedScanId; });
        });
    }, [findProductByIdOrSku, productSkuUpcList, shipmentItemDetailList]);
    // local barcode resolution — shipment products, kit components, then the
    // scanIdGeneral cache. Anything found here can enqueue with zero network calls.
    var resolveScanProductLocally = useCallback(function (scanId) {
        var trimmed = scanId.trim();
        if (!trimmed)
            return null;
        var matchedProduct = findProductByIdOrSku(trimmed);
        if (matchedProduct === null || matchedProduct === void 0 ? void 0 : matchedProduct.productId)
            return { productId: matchedProduct.productId };
        var matchedKit = findKitProductByIdOrSku(trimmed);
        if (matchedKit === null || matchedKit === void 0 ? void 0 : matchedKit.componentProductId)
            return { productId: matchedKit.componentProductId };
        var cached = scanIdCache[localStorage.getItem('activeOrgId') + "|" + trimmed];
        if (cached === null || cached === void 0 ? void 0 : cached.productId) {
            // a cached resolution still has to belong to this shipment
            var inShipment = (shipmentItemDetailList || []).some(function (item) { return item.productId === cached.productId || (cached.pseudoId && item.pseudoId === cached.pseudoId); }) ||
                (kitComponentProducts || []).some(function (item) { return item.componentProductId === cached.productId; });
            if (inShipment)
                return { productId: cached.productId };
        }
        return null;
    }, [findProductByIdOrSku, findKitProductByIdOrSku, scanIdCache, shipmentItemDetailList, kitComponentProducts]);
    // force server resolution for container barcodes (no queue)
    // Matches the C-prefixed license plate pattern
    var isContainerLikeScanId = useCallback(function (scanId) {
        var trimmed = scanId.trim();
        if (!trimmed)
            return false;
        if (/^C\d+$/i.test(trimmed))
            return true;
        return (shipmentContainerList || []).some(function (container) { return container.containerId === trimmed || container.serialNumber === trimmed; });
    }, [shipmentContainerList]);
    // the moment a product's queued quantity reaches what the shipment
    // still needs, flush instead of waiting out the debounce.
    var flushIfProductCapReached = useCallback(function (targetShipmentId, productId) {
        var detailItems = (shipmentItemDetailList || []).filter(function (item) { return item.productId === productId; });
        // no matching shipment item (e.g. kit component) — no local cap to enforce
        if (detailItems.length === 0)
            return;
        var remaining = detailItems.reduce(function (sum, item) { return sum + Number(item.quantityNotHandled || 0); }, 0);
        // nothing left to pack — the scans are doomed either way, so let the
        // window batch them into one attributed failure instead of flushing
        // (and POSTing) once per scan
        if (remaining <= 0)
            return;
        if (getQueuedQuantityForProduct(targetShipmentId, productId) >= remaining) {
            void flushScanQueueNow(targetShipmentId);
        }
    }, [shipmentItemDetailList]);
    // assembly component scans register on the shipment-level assembly task
    var notifyAssemblyComponentScan = useCallback(function (scanId, quantity) {
        var _a;
        var matchedComponent = findKitProductByIdOrSku(scanId.trim());
        if (!matchedComponent)
            return;
        // a component that is also ordered directly gets packed against its own item source first,
        // so this scan went into the container, not the assembly task
        var hasDirectRemaining = (shipmentItemSourceList || []).some(function (source) {
            return (source === null || source === void 0 ? void 0 : source.productId) === matchedComponent.componentProductId &&
                Number((source === null || source === void 0 ? void 0 : source.quantityNotHandled) || 0) > 0;
        });
        if (hasDirectRemaining)
            return;
        var componentName = matchedComponent.productName || matchedComponent.sku || matchedComponent.componentProductId;
        var workEffortId = (_a = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.assemblyWorkEffort) === null || _a === void 0 ? void 0 : _a.workEffortId;
        pushScanInfo("" + t('Added to assembly task') + (workEffortId ? " #" + workEffortId : '') + ": " + componentName + " \u00D7" + quantity);
    }, [findKitProductByIdOrSku, shipmentItemSourceList, shipmentData, t]);
    // the scan queue is bound once per shipment; route its callbacks through a ref
    // so batch feedback always uses the freshest assembly data
    var notifyAssemblyComponentScanRef = useRef(notifyAssemblyComponentScan);
    useEffect(function () {
        notifyAssemblyComponentScanRef.current = notifyAssemblyComponentScan;
    }, [notifyAssemblyComponentScan]);
    // bind the scan-queue executor for this shipment
    useEffect(function () {
        if (!shipmentId)
            return;
        configureScanQueue(shipmentId, {
            packBatch: function (item) {
                return dispatch(packItem({
                    shipmentId: shipmentId,
                    scanInput: item.scanId,
                    quantity: item.quantity,
                    shipmentPackageSeqId: item.shipmentPackageSeqId,
                    shipmentBoxTypeId: item.shipmentBoxTypeId,
                    suppressRefresh: true,
                    quiet: true
                })).unwrap();
            },
            containerBatch: function (item) {
                return dispatch(containerScan({
                    shipmentId: shipmentId,
                    scanInput: item.scanId,
                    packIntoContainerId: item.packIntoContainerId,
                    quantity: item.quantity,
                    suppressRefresh: true,
                    quiet: true
                })).unwrap();
            },
            refresh: function () { return dispatch(fetchShipmentDetails({ shipmentId: shipmentId, silent: true })); },
            onStatus: function (pendingCount, flushing) { return dispatch(setScanQueueStatus({ pendingCount: pendingCount, flushing: flushing })); },
            onBatchSuccess: function (item) {
                boopScanRegistered(item.scanCount);
                notifyAssemblyComponentScanRef.current(item.scanId, item.quantity);
            },
            onErrors: function (failures) {
                buzzScanError(failures.reduce(function (sum, failure) { return sum + failure.scanCount; }, 0));
                failures.forEach(function (failure) {
                    pushScanError(failure.scanId + " \u00D7" + failure.quantity + ": " + failure.message);
                });
            }
        });
        return function () {
            // leaving the screen / switching shipments: push out anything still queued
            void flushScanQueueNow(shipmentId);
            clearScanErrors();
        };
    }, [dispatch, shipmentId]);
    useEffect(function () {
        var _a;
        if (!pendingVirtualResolution)
            return;
        var beforeSeqIds = new Set(pendingVirtualResolution.beforePackageSeqIds);
        var createdPackageSeqId = ((_a = shipmentPackages
            .map(function (shipmentPackage, index) { return ({ shipmentPackage: shipmentPackage, index: index }); })
            .filter(function (_a) {
            var shipmentPackage = _a.shipmentPackage;
            return !beforeSeqIds.has(shipmentPackage.shipmentPackageSeqId);
        })
            .reduce(function (selected, candidate) {
            if (!selected)
                return candidate;
            var selectedCreatedAt = Date.parse(selected.shipmentPackage.dateCreated || '');
            var candidateCreatedAt = Date.parse(candidate.shipmentPackage.dateCreated || '');
            var selectedHasCreatedAt = Number.isFinite(selectedCreatedAt);
            var candidateHasCreatedAt = Number.isFinite(candidateCreatedAt);
            if (selectedHasCreatedAt && candidateHasCreatedAt && selectedCreatedAt !== candidateCreatedAt) {
                return candidateCreatedAt > selectedCreatedAt ? candidate : selected;
            }
            var selectedSeqIdNumber = Number(selected.shipmentPackage.shipmentPackageSeqId);
            var candidateSeqIdNumber = Number(candidate.shipmentPackage.shipmentPackageSeqId);
            var selectedHasNumericSeqId = Number.isFinite(selectedSeqIdNumber);
            var candidateHasNumericSeqId = Number.isFinite(candidateSeqIdNumber);
            if (selectedHasNumericSeqId &&
                candidateHasNumericSeqId &&
                selectedSeqIdNumber !== candidateSeqIdNumber) {
                return candidateSeqIdNumber > selectedSeqIdNumber ? candidate : selected;
            }
            return candidate.index > selected.index ? candidate : selected;
        }, null)) === null || _a === void 0 ? void 0 : _a.shipmentPackage.shipmentPackageSeqId) || null;
        if (createdPackageSeqId) {
            materializeVirtualPackage(pendingVirtualResolution.tempId, createdPackageSeqId);
            setPendingVirtualResolution(null);
        }
    }, [materializeVirtualPackage, pendingVirtualResolution, shipmentPackages]);
    useEffect(function () {
        if ((selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return;
        var stillExists = shipmentPackages.some(function (shipmentPackage) { return shipmentPackage.shipmentPackageSeqId === selectedPackageRef.seqId; });
        if (!stillExists) {
            setSelectedPackageRef(null);
            setIsCloseModalVisible(false);
            setUpdatePackageModalVisible(false);
        }
    }, [selectedPackageRef, shipmentPackages]);
    var handleBack = useCallback(function () {
        clearShipment();
        setSelectedPackageRef(null);
        setVirtualPackages([]);
        setPendingVirtualResolution(null);
        setPendingSerializedPackRequest(null);
        setPendingScanId(null);
        setSerialNumberModalVisible(false);
        setUpdatePackageModalVisible(false);
        setBulkPackModalVisible(false);
        setIsCloseModalVisible(false);
        setReturnLabelModalVisible(false);
        if (scanThroughPack) {
            navigateToSubscreen(PackingSubscreen.ShipmentList);
        }
        else {
            navigateToSubscreen(PackingSubscreen.ShipmentId);
        }
    }, [clearShipment, navigateToSubscreen, scanThroughPack]);
    var handleNewPackage = useCallback(function (boxTypeId) {
        var tempId = "virtual-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8);
        setVirtualPackages(function (prev) {
            var maxRealPackageNumber = shipmentPackages.reduce(function (maxNumber, shipmentPackage) {
                var packageNumber = Number(shipmentPackage.shipmentPackageSeqId);
                if (Number.isFinite(packageNumber) && packageNumber > maxNumber) {
                    return packageNumber;
                }
                return maxNumber;
            }, 0);
            var maxVirtualPackageNumber = prev.reduce(function (maxNumber, virtualPackage) {
                if (virtualPackage.displayPackageNumber > maxNumber) {
                    return virtualPackage.displayPackageNumber;
                }
                return maxNumber;
            }, 0);
            var nextDisplayPackageNumber = Math.max(maxRealPackageNumber, maxVirtualPackageNumber) + 1;
            return __spreadArray(__spreadArray([], prev, true), [
                __assign({ tempId: tempId, displayPackageNumber: nextDisplayPackageNumber }, (boxTypeId ? { shipmentBoxTypeId: boxTypeId } : {}))
            ], false);
        });
        setSelectedPackageRef({ kind: 'virtual', tempId: tempId });
        setPendingVirtualResolution(null);
        setIsCloseModalVisible(false);
        setScanInputFocusSignal(function (prev) { return prev + 1; });
    }, [shipmentPackages]);
    var handleSidebarPackageSelect = useCallback(function (packageRef, _pkgIsClosed) {
        var isSameSelection = !!selectedPackageRef &&
            ((packageRef.kind === 'real' &&
                selectedPackageRef.kind === 'real' &&
                selectedPackageRef.seqId === packageRef.seqId) ||
                (packageRef.kind === 'virtual' &&
                    selectedPackageRef.kind === 'virtual' &&
                    selectedPackageRef.tempId === packageRef.tempId));
        if (isSameSelection) {
            setSelectedPackageRef(null);
            setIsCloseModalVisible(false);
            setUpdatePackageModalVisible(false);
            return;
        }
        setSelectedPackageRef(packageRef);
        setSelectedContainerRef(null);
        setPendingVirtualResolution(null);
        setPendingSerializedPackRequest(null);
        setPendingScanId(null);
        setSerialNumberModalVisible(false);
        setIsCloseModalVisible(false);
        setUpdatePackageModalVisible(false);
        setScanInputFocusSignal(function (prev) { return prev + 1; });
    }, [selectedPackageRef]);
    var resolveRootContainerIdForRef = useCallback(function (ref) {
        var _a;
        var c = shipmentContainerList.find(function (x) { return x.containerId === ref.containerId; });
        if (!c)
            return null;
        return c.isRoot ? c.containerId : (_a = c.parentContainerId) !== null && _a !== void 0 ? _a : null;
    }, [shipmentContainerList]);
    var requestContainerSwitch = useCallback(function (target, apply) {
        // the outgoing container may still have queued scans, flush
        if (shipmentId)
            void flushScanQueueNow(shipmentId);
        var decision = decideContainerSwitch({
            target: target,
            selectedRef: selectedContainerRef,
            containers: shipmentContainerList,
            packerById: containerPackerById,
            currentUserPartyId: currentUserPartyId,
            resolveRootId: resolveRootContainerIdForRef,
            openStatusId: ContainerStatus.Open
        });
        if (decision.action === 'warn') {
            setPendingContainerSwitch({ apply: apply, reason: decision.reason, packerName: decision.packerName });
            return;
        }
        apply();
    }, [selectedContainerRef, shipmentContainerList, containerPackerById, currentUserPartyId, resolveRootContainerIdForRef, shipmentId]);
    var handleSidebarContainerSelect = useCallback(function (containerRef) {
        var isSameSelection = !!selectedContainerRef && containerRef.containerId === selectedContainerRef.containerId;
        if (isSameSelection) {
            requestContainerSwitch(null, function () {
                setSelectedContainerRef(null);
                setScanInputFocusSignal(function (prev) { return prev + 1; });
            });
            return;
        }
        requestContainerSwitch(containerRef, function () {
            setSelectedContainerRef(containerRef);
            setSelectedPackageRef(null);
            setScanInputFocusSignal(function (prev) { return prev + 1; });
        });
    }, [selectedContainerRef, requestContainerSwitch]);
    var isCreatingContainerRef = useRef(false);
    var createContainerAndSelect = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var result, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (isCreatingContainerRef.current)
                        return [2 /*return*/];
                    isCreatingContainerRef.current = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, handleCreateContainer(params)];
                case 2:
                    result = _b.sent();
                    if (result === null || result === void 0 ? void 0 : result.containerId) {
                        setSelectedContainerRef({ kind: 'real', containerId: result.containerId });
                        setSelectedPackageRef(null);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    isCreatingContainerRef.current = false;
                    setScanInputFocusSignal(function (prev) { return prev + 1; });
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [handleCreateContainer]);
    var handlePaneContainerSelect = useCallback(function (containerId) {
        setSelectedContainerRef(function (previousSelection) {
            if ((previousSelection === null || previousSelection === void 0 ? void 0 : previousSelection.kind) === 'real' &&
                previousSelection.containerId === containerId) {
                return previousSelection;
            }
            return { kind: 'real', containerId: containerId };
        });
        setSelectedPackageRef(null);
        setScanInputFocusSignal(function (prev) { return prev + 1; });
    }, []);
    var handlePackForSelectedPackage = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedPackageAtSubmit, beforePackageSeqIds, scanResult, resolvedPackageSeqId, resolvedPackageSeqId, tempId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedPackageAtSubmit = selectedPackageRef;
                    beforePackageSeqIds = shipmentPackages.map(function (pkg) { return pkg.shipmentPackageSeqId; });
                    return [4 /*yield*/, handleScanProduct({
                            scanId: params.scanId,
                            shipmentItemDetailList: shipmentItemDetailList || [],
                            kitComponentProducts: kitComponentProducts || [],
                            quantity: params.quantity,
                            carton: params.carton,
                            serialNumber: params.serialNumber,
                            shipmentPackageSeqId: params.shipmentPackageSeqId,
                            shipmentBoxTypeId: params.shipmentBoxTypeId
                        })];
                case 1:
                    scanResult = _a.sent();
                    if ((selectedPackageAtSubmit === null || selectedPackageAtSubmit === void 0 ? void 0 : selectedPackageAtSubmit.kind) === 'virtual') {
                        resolvedPackageSeqId = resolveShipmentPackageSeqIdFromScanResult(scanResult);
                        if (resolvedPackageSeqId) {
                            materializeVirtualPackage(selectedPackageAtSubmit.tempId, resolvedPackageSeqId);
                            setPendingVirtualResolution(null);
                        }
                        else {
                            setPendingVirtualResolution({
                                tempId: selectedPackageAtSubmit.tempId,
                                beforePackageSeqIds: beforePackageSeqIds
                            });
                        }
                    }
                    else if (!selectedPackageAtSubmit) {
                        resolvedPackageSeqId = resolveShipmentPackageSeqIdFromScanResult(scanResult);
                        if (resolvedPackageSeqId) {
                            setSelectedPackageRef({ kind: 'real', seqId: resolvedPackageSeqId });
                        }
                        else {
                            tempId = "virtual-scan-" + Date.now();
                            setSelectedPackageRef({ kind: 'virtual', tempId: tempId });
                            setPendingVirtualResolution({
                                tempId: tempId,
                                beforePackageSeqIds: beforePackageSeqIds
                            });
                        }
                    }
                    return [2 /*return*/, scanResult];
            }
        });
    }); }, [
        selectedPackageRef,
        shipmentPackages,
        handleScanProduct,
        shipmentItemDetailList,
        kitComponentProducts,
        resolveShipmentPackageSeqIdFromScanResult,
        materializeVirtualPackage
    ]);
    var handlePackRequest = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            if (!params.serialNumber && isSerializedScanId(params.scanId)) {
                setPendingScanId(params.scanId);
                setPendingSerializedPackRequest({
                    surface: 'package',
                    scanId: params.scanId,
                    quantity: params.quantity,
                    carton: params.carton,
                    shipmentPackageSeqId: (_b = (_a = params.shipmentPackageSeqId) !== null && _a !== void 0 ? _a : selectedPackageSeqId) !== null && _b !== void 0 ? _b : undefined,
                    shipmentBoxTypeId: (_c = params.shipmentBoxTypeId) !== null && _c !== void 0 ? _c : selectedVirtualPackage === null || selectedVirtualPackage === void 0 ? void 0 : selectedVirtualPackage.shipmentBoxTypeId
                });
                setSerialNumberModalVisible(true);
                return [2 /*return*/, { deferredSerialPrompt: true }];
            }
            return [2 /*return*/, handlePackForSelectedPackage(params)];
        });
    }); }, [isSerializedScanId, selectedPackageSeqId, selectedVirtualPackage, handlePackForSelectedPackage]);
    var handleAdvanceToClose = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real' || (selectedPackageInfo === null || selectedPackageInfo === void 0 ? void 0 : selectedPackageInfo.isClosed)) {
                        return [2 /*return*/];
                    }
                    if (!shipmentId) return [3 /*break*/, 2];
                    return [4 /*yield*/, flushScanQueueNow(shipmentId)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    setIsCloseModalVisible(true);
                    return [2 /*return*/];
            }
        });
    }); }, [selectedPackageInfo, selectedPackageRef, selectedPackageSeqId, shipmentId]);
    var handlePackageClosed = useCallback(function () {
        setIsCloseModalVisible(false);
    }, []);
    var handleOpenUpdatePackage = useCallback(function () {
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return;
        setUpdatePackageModalVisible(true);
    }, [selectedPackageRef, selectedPackageSeqId]);
    var handleScannerDelete = useCallback(function () {
        setSelectedPackageRef(function (prev) {
            if ((prev === null || prev === void 0 ? void 0 : prev.kind) === 'virtual') {
                setVirtualPackages(function (virtuals) { return virtuals.filter(function (pkg) { return pkg.tempId !== prev.tempId; }); });
            }
            return null;
        });
        setPendingVirtualResolution(null);
        setPendingSerializedPackRequest(null);
        setPendingScanId(null);
        setSerialNumberModalVisible(false);
        setIsCloseModalVisible(false);
        setUpdatePackageModalVisible(false);
        setReturnLabelModalVisible(false);
    }, []);
    var handleConfirmCancel = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // cancell any queued scans
                    if (shipmentId)
                        clearScanQueue(shipmentId);
                    return [4 /*yield*/, handleCancelShipment()];
                case 1:
                    _a.sent();
                    clearShipment();
                    setSelectedPackageRef(null);
                    setVirtualPackages([]);
                    setPendingVirtualResolution(null);
                    setPendingSerializedPackRequest(null);
                    setPendingScanId(null);
                    setSerialNumberModalVisible(false);
                    setUpdatePackageModalVisible(false);
                    setBulkPackModalVisible(false);
                    setIsCloseModalVisible(false);
                    setReturnLabelModalVisible(false);
                    navigateToSubscreen(PackingSubscreen.ShipmentId);
                    return [2 /*return*/];
            }
        });
    }); }, [handleCancelShipment, clearShipment, navigateToSubscreen, shipmentId]);
    var handleResetPackage = useCallback(function (seqId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setResettingPackage(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, resetPackage(seqId)];
                case 2:
                    _b.sent();
                    message.success(t('Package has been reopened for scanning'));
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    message.error(t('Failed to reset package'));
                    return [3 /*break*/, 5];
                case 4:
                    setResettingPackage(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [resetPackage, t]);
    var handleResetAllPackagesAction = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleResetAllPackages()];
                case 1:
                    _a.sent();
                    setIsCloseModalVisible(false);
                    return [2 /*return*/];
            }
        });
    }); }, [handleResetAllPackages]);
    var handleDeleteAllPackagesAction = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleDeleteAllPackages()];
                case 1:
                    _a.sent();
                    setSelectedPackageRef(null);
                    setVirtualPackages([]);
                    setPendingVirtualResolution(null);
                    setPendingSerializedPackRequest(null);
                    setPendingScanId(null);
                    setSerialNumberModalVisible(false);
                    setUpdatePackageModalVisible(false);
                    setBulkPackModalVisible(false);
                    setIsCloseModalVisible(false);
                    setReturnLabelModalVisible(false);
                    return [2 /*return*/];
            }
        });
    }); }, [handleDeleteAllPackages]);
    var palletAllowed = useMemo(function () { return isPalletPackingAllowed(shipmentData); }, [shipmentData]);
    var palletDisabledTooltip = getPalletDisabledReason(shipmentData);
    // Block root carton creation once the shipment has pallets; the Carton button
    // stays enabled while an open root pallet as it adds a child carton
    var cartonDisabled = useMemo(function () {
        var hasPallet = shipmentContainerList.some(function (c) { return c.containerTypeEnumId === 'CtPallet'; });
        if (!hasPallet)
            return false;
        var selected = selectedRealContainerId
            ? shipmentContainerList.find(function (c) { return c.containerId === selectedRealContainerId; })
            : null;
        return !((selected === null || selected === void 0 ? void 0 : selected.isRoot) &&
            selected.containerTypeEnumId === 'CtPallet' &&
            selected.statusId === ContainerStatus.Open);
    }, [shipmentContainerList, selectedRealContainerId]);
    var canGetMainLabel = useMemo(function () {
        var routeSegment = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0];
        var hasShippingGatewayConfig = Boolean((shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shippingGatewayConfigId) || (routeSegment === null || routeSegment === void 0 ? void 0 : routeSegment.shippingGatewayConfigId));
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return false;
        return (!(selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.trackingCode) &&
            !(selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.gatewayLabelId) &&
            !!(selectedPackageInfo === null || selectedPackageInfo === void 0 ? void 0 : selectedPackageInfo.shipmentBoxTypeId) &&
            hasShippingGatewayConfig);
    }, [
        selectedPackageInfo,
        selectedPackageRef,
        selectedPackageRouteSegment,
        selectedPackageSeqId,
        shipmentData,
        shipmentRouteSegments
    ]);
    var canDownloadMainLabel = useMemo(function () {
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return false;
        return Boolean((selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.gatewayLabelId) ||
            (selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.labelImage) ||
            (selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.labelUrl));
    }, [selectedPackageRef, selectedPackageRouteSegment, selectedPackageSeqId]);
    var canRequestReturnLabel = useMemo(function () {
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return false;
        return Boolean((selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.trackingCode) && !(selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.returnTrackingCode));
    }, [selectedPackageRef, selectedPackageRouteSegment, selectedPackageSeqId]);
    var canUseReturnLabel = useMemo(function () {
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return false;
        return Boolean(selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.returnTrackingCode);
    }, [selectedPackageRef, selectedPackageRouteSegment, selectedPackageSeqId]);
    var canRefundLabel = useMemo(function () {
        var _a;
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return false;
        return Boolean((selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.trackingCode) && ((_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.carrierPartyId));
    }, [selectedPackageRef, selectedPackageRouteSegment, selectedPackageSeqId, shipmentRouteSegments]);
    var handleGetMainLabelForSelectedPackage = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var shipmentRouteSegmentSeqId, fetchMainLabel;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!selectedPackageSeqId)
                        return [2 /*return*/];
                    shipmentRouteSegmentSeqId = (_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.shipmentRouteSegmentSeqId;
                    if (!shipmentRouteSegmentSeqId) {
                        message.error(t('Something went wrong'));
                        return [2 /*return*/];
                    }
                    fetchMainLabel = function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, handleGetMainLabel({
                                        shipmentPackageSeqId: selectedPackageSeqId,
                                        shipmentRouteSegmentSeqId: shipmentRouteSegmentSeqId
                                    })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    if (!selectedPackageHasContents) {
                        message.error(t('Something went wrong'));
                        return [2 /*return*/];
                    }
                    if (!destContactMechValid) {
                        confirm({
                            title: 'Warning: destination address is incomplete or invalid according to address validation',
                            icon: _jsx(ExclamationCircleOutlined, {}, void 0),
                            onOk: fetchMainLabel,
                            onCancel: function () { },
                            okText: t('Get Label Anyway')
                        });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetchMainLabel()];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [
        confirm,
        destContactMechValid,
        handleGetMainLabel,
        selectedPackageHasContents,
        selectedPackageSeqId,
        shipmentRouteSegments,
        t
    ]);
    var handleDownloadMainLabel = useCallback(function () {
        var _a;
        if (!shipmentId || !selectedPackageSeqId)
            return;
        var shipmentRouteSegmentSeqId = (_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.shipmentRouteSegmentSeqId;
        if (!shipmentRouteSegmentSeqId)
            return;
        var url = process.env.REACT_APP_API_BASE_URL + "/rest/s1/handheld/pack/shipment/" + shipmentId + "/label?shipmentRouteSegmentSeqId=" + shipmentRouteSegmentSeqId + "&shipmentPackageSeqId=" + selectedPackageSeqId;
        window.open(url, '_blank');
    }, [shipmentId, selectedPackageSeqId, shipmentRouteSegments]);
    var handleOpenReturnLabelModal = useCallback(function () {
        if (!selectedPackageSeqId)
            return;
        setReturnLabelModalVisible(true);
    }, [selectedPackageSeqId]);
    var handleDownloadReturnLabel = useCallback(function () {
        var _a;
        if (!shipmentId || !selectedPackageSeqId)
            return;
        var shipmentRouteSegmentSeqId = (_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.shipmentRouteSegmentSeqId;
        if (!shipmentRouteSegmentSeqId)
            return;
        var url = process.env.REACT_APP_API_BASE_URL + "/rest/s1/handheld/pack/shipment/" + shipmentId + "/label?shipmentRouteSegmentSeqId=" + shipmentRouteSegmentSeqId + "&shipmentPackageSeqId=" + selectedPackageSeqId + "&retLabel=true";
        window.open(url, '_blank');
    }, [shipmentId, selectedPackageSeqId, shipmentRouteSegments]);
    var handlePrintReturnLabel = useCallback(function () {
        if (!selectedPackageSeqId)
            return;
        void printReturnLabel(selectedPackageSeqId, { context: t('Return label') });
    }, [printReturnLabel, selectedPackageSeqId, t]);
    var handleRefundLabelForSelectedPackage = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectedRouteSegment, carrierPartyId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedPackageSeqId)
                        return [2 /*return*/];
                    selectedRouteSegment = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0];
                    carrierPartyId = selectedRouteSegment === null || selectedRouteSegment === void 0 ? void 0 : selectedRouteSegment.carrierPartyId;
                    if (!carrierPartyId)
                        return [2 /*return*/];
                    return [4 /*yield*/, handleRefundLabel({
                            shipmentPackageSeqId: selectedPackageSeqId,
                            carrierPartyId: carrierPartyId,
                            shippingGatewayConfigId: selectedRouteSegment === null || selectedRouteSegment === void 0 ? void 0 : selectedRouteSegment.shippingGatewayConfigId
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [handleRefundLabel, selectedPackageSeqId, shipmentRouteSegments]);
    var handleSerialNumberSubmit = useCallback(function (serialNumber) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pendingSerializedPackRequest)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!(pendingSerializedPackRequest.surface === 'container')) return [3 /*break*/, 3];
                    return [4 /*yield*/, handleContainerScan({
                            scanInput: pendingSerializedPackRequest.scanId,
                            quantity: pendingSerializedPackRequest.quantity,
                            serialNumber: serialNumber,
                            packIntoContainerId: pendingSerializedPackRequest.packIntoContainerId,
                            containerTypeEnumId: pendingSerializedPackRequest.containerTypeEnumId
                        })
                        // select the container the scan just created
                    ];
                case 2:
                    result = _a.sent();
                    // select the container the scan just created
                    if (result === null || result === void 0 ? void 0 : result.containerId) {
                        setSelectedContainerRef({ kind: 'real', containerId: result.containerId });
                        if (!pendingSerializedPackRequest.packIntoContainerId)
                            setSelectedPackageRef(null);
                    }
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, handlePackForSelectedPackage({
                        scanId: pendingSerializedPackRequest.scanId,
                        quantity: pendingSerializedPackRequest.quantity,
                        carton: pendingSerializedPackRequest.carton,
                        serialNumber: serialNumber,
                        shipmentPackageSeqId: pendingSerializedPackRequest.shipmentPackageSeqId,
                        shipmentBoxTypeId: pendingSerializedPackRequest.shipmentBoxTypeId
                    })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    boopScanRegistered();
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    buzzScanError();
                    throw error_1;
                case 7:
                    setSerialNumberModalVisible(false);
                    setPendingSerializedPackRequest(null);
                    setPendingScanId(null);
                    setScanInputFocusSignal(function (prev) { return prev + 1; });
                    return [2 /*return*/];
            }
        });
    }); }, [pendingSerializedPackRequest, handlePackForSelectedPackage, handleContainerScan]);
    var productStoreId = (_b = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipment) === null || _b === void 0 ? void 0 : _b.productStoreId;
    var packerName = useMemo(function () { return localStorage.getItem('loggedInUserName') || '-'; }, []);
    var isRefreshingShipment = loading.shipment;
    var handleRefreshShipment = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId || isRefreshingShipment)
                        return [2 /*return*/];
                    return [4 /*yield*/, loadShipmentDetails(shipmentId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [shipmentId, isRefreshingShipment, loadShipmentDetails]);
    var startBulkLabelPrint = useCallback(function (containerIds) {
        if (containerIds.length === 0)
            return;
        var hide = message.loading(t('Printing {{count}} labels…', { count: containerIds.length }), 0);
        void printContainerLabel(containerIds, {
            context: t('{{count}} container labels', { count: containerIds.length })
        }).finally(hide);
    }, [printContainerLabel, t]);
    var handleBulkPackSubmit = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var serializedItem, bulkPackResult;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    serializedItem = params.items.find(function (item) { return isSerializedScanId(item.scanId); });
                    if (serializedItem) {
                        buzzScanError();
                        pushScanError(t('Bulk packing is not allowed for serialized products'));
                        // throw, don't return: the modal treats a resolved submit as success and would clear
                        throw new Error('serialized product rejected');
                    }
                    return [4 /*yield*/, handleBulkCreateContainers({
                            scanItems: params.items.map(function (item) { return ({
                                scanInput: item.scanId,
                                quantityPerContainer: item.quantity
                            }); }),
                            numberOfContainers: params.carton,
                            containerTypeEnumId: 'CtCarton',
                            weight: params.weight,
                            shipmentBoxTypeId: params.shipmentBoxTypeId,
                            weightUomId: 'WT_lb'
                        })];
                case 1:
                    bulkPackResult = _b.sent();
                    if (!(bulkPackResult === null || bulkPackResult === void 0 ? void 0 : bulkPackResult.containerIdList)) return [3 /*break*/, 3];
                    return [4 /*yield*/, handleBulkCloseContainers({
                            containerIds: bulkPackResult.containerIdList,
                            shipmentBoxTypeId: params.shipmentBoxTypeId,
                            weight: params.weight,
                            weightUomId: 'WT_lb',
                        })];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    setBulkPackModalVisible(false);
                    setSelectedPackageRef(null);
                    setPendingVirtualResolution(null);
                    setIsCloseModalVisible(false);
                    setUpdatePackageModalVisible(false);
                    if (params.autoPrintLabels && ((_a = bulkPackResult === null || bulkPackResult === void 0 ? void 0 : bulkPackResult.containerIdList) === null || _a === void 0 ? void 0 : _a.length)) {
                        startBulkLabelPrint(bulkPackResult.containerIdList);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [handleBulkCreateContainers, handleBulkCloseContainers, startBulkLabelPrint, isSerializedScanId, t]);
    var handleScanToPack = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var prefillData, resolved, result, _a, containerTypeEnumId, result, _b, packResult, error_2;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    autoComplete.notifyScanActivity();
                    // route to bulk packing dialogs with inputs
                    if (params.quantityMode === 'bulk') {
                        // do not allow bulk packing if product is serialized
                        if (isSerializedScanId(params.scanId)) {
                            buzzScanError();
                            pushScanError(t('Bulk packing is not allowed for serialized products'));
                            return [2 /*return*/];
                        }
                        prefillData = { scanId: params.scanId, quantity: params.quantity };
                        if (params.scanMode === 'carton') {
                            (_c = bulkPackModalRef.current) === null || _c === void 0 ? void 0 : _c.prefill(prefillData);
                            setBulkPackModalVisible(true);
                        }
                        else if (params.scanMode === 'pallet') {
                            (_d = bulkContainerModalRef.current) === null || _d === void 0 ? void 0 : _d.prefill(prefillData);
                            setBulkContainerModalVisible(true);
                        }
                        return [2 /*return*/];
                    }
                    if (!shipmentId) return [3 /*break*/, 2];
                    resolved = isContainerLikeScanId(params.scanId)
                        ? null
                        : resolveScanProductLocally(params.scanId);
                    if (resolved && !isSerializedScanId(params.scanId)) {
                        // no boop here — feedback plays per scan when the flush batch settles,
                        // so what the worker hears is what the backend confirmed
                        if (selectedContainerRef && activeContainerTypeEnumId === 'CtCarton') {
                            enqueueScan(shipmentId, {
                                surface: 'container',
                                scanId: params.scanId.trim(),
                                productId: resolved.productId,
                                quantity: params.quantity,
                                packIntoContainerId: selectedContainerRef.containerId
                            });
                            flushIfProductCapReached(shipmentId, resolved.productId);
                            return [2 /*return*/, { enqueued: true }];
                        }
                        if (!selectedContainerRef && (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) === 'real') {
                            enqueueScan(shipmentId, {
                                surface: 'package',
                                scanId: params.scanId.trim(),
                                productId: resolved.productId,
                                quantity: params.quantity,
                                shipmentPackageSeqId: selectedPackageRef.seqId
                            });
                            flushIfProductCapReached(shipmentId, resolved.productId);
                            return [2 /*return*/, { enqueued: true }];
                        }
                    }
                    // everything else (serialized, unresolved, pallet/new-target scans) must run
                    // against settled server state — drain the queue first
                    return [4 /*yield*/, flushScanQueueNow(shipmentId)];
                case 1:
                    // everything else (serialized, unresolved, pallet/new-target scans) must run
                    // against settled server state — drain the queue first
                    _e.sent();
                    _e.label = 2;
                case 2:
                    if (!selectedContainerRef) return [3 /*break*/, 6];
                    // serialized products must prompt for the serial here too — without this
                    // gate the container flow packed them with no serial recorded at all
                    if (isSerializedScanId(params.scanId)) {
                        setPendingScanId(params.scanId);
                        setPendingSerializedPackRequest({
                            surface: 'container',
                            scanId: params.scanId,
                            quantity: params.quantity,
                            packIntoContainerId: selectedContainerRef.containerId
                        });
                        setSerialNumberModalVisible(true);
                        return [2 /*return*/, { deferredSerialPrompt: true }];
                    }
                    _e.label = 3;
                case 3:
                    _e.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, handleContainerScan({
                            scanInput: params.scanId,
                            quantity: params.quantity,
                            packIntoContainerId: selectedContainerRef.containerId
                        })];
                case 4:
                    result = _e.sent();
                    if (result === null || result === void 0 ? void 0 : result.containerId) {
                        setSelectedContainerRef({ kind: 'real', containerId: result.containerId });
                    }
                    boopScanRegistered();
                    notifyAssemblyComponentScan(params.scanId, params.quantity);
                    setScanInputFocusSignal(function (prev) { return prev + 1; });
                    return [2 /*return*/, result];
                case 5:
                    _a = _e.sent();
                    buzzScanError();
                    return [2 /*return*/, undefined];
                case 6:
                    if (!(params.scanMode && ['carton', 'pallet'].includes(params.scanMode) && !selectedPackageRef)) return [3 /*break*/, 10];
                    containerTypeEnumId = params.scanMode === 'pallet' ? 'CtPallet' : 'CtCarton';
                    // same serial gate for the create-and-pack path (container barcodes are
                    // never serialized product scans, so they fall through untouched)
                    if (isSerializedScanId(params.scanId)) {
                        setPendingScanId(params.scanId);
                        setPendingSerializedPackRequest({
                            surface: 'container',
                            scanId: params.scanId,
                            quantity: params.quantity,
                            containerTypeEnumId: containerTypeEnumId
                        });
                        setSerialNumberModalVisible(true);
                        return [2 /*return*/, { deferredSerialPrompt: true }];
                    }
                    _e.label = 7;
                case 7:
                    _e.trys.push([7, 9, , 10]);
                    return [4 /*yield*/, handleContainerScan({
                            scanInput: params.scanId,
                            quantity: params.quantity,
                            containerTypeEnumId: containerTypeEnumId
                        })
                        // Select the newly created container
                    ];
                case 8:
                    result = _e.sent();
                    // Select the newly created container
                    if (result === null || result === void 0 ? void 0 : result.containerId) {
                        setSelectedContainerRef({ kind: 'real', containerId: result.containerId });
                        setSelectedPackageRef(null);
                    }
                    boopScanRegistered();
                    notifyAssemblyComponentScan(params.scanId, params.quantity);
                    setScanInputFocusSignal(function (prev) { return prev + 1; });
                    return [2 /*return*/, result];
                case 9:
                    _b = _e.sent();
                    buzzScanError();
                    return [2 /*return*/, undefined];
                case 10:
                    _e.trys.push([10, 12, , 13]);
                    return [4 /*yield*/, handlePackRequest({
                            scanId: params.scanId,
                            quantity: params.quantity,
                            shipmentPackageSeqId: (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) === 'real' ? selectedPackageRef.seqId : undefined,
                            shipmentBoxTypeId: (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) === 'virtual'
                                ? selectedVirtualPackage === null || selectedVirtualPackage === void 0 ? void 0 : selectedVirtualPackage.shipmentBoxTypeId
                                : undefined
                        })];
                case 11:
                    packResult = _e.sent();
                    return [3 /*break*/, 13];
                case 12:
                    error_2 = _e.sent();
                    buzzScanError();
                    throw error_2;
                case 13:
                    if (!(packResult && 'deferredSerialPrompt' in packResult && packResult.deferredSerialPrompt)) {
                        // deferred serial prompts boop later, when the serial actually submits
                        boopScanRegistered();
                        setScanInputFocusSignal(function (prev) { return prev + 1; });
                    }
                    return [2 /*return*/, packResult];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        selectedPackageRef,
        selectedVirtualPackage,
        handlePackRequest,
        selectedContainerRef,
        handleContainerScan,
        shipmentId,
        resolveScanProductLocally,
        flushIfProductCapReached,
        isContainerLikeScanId,
        isSerializedScanId,
        notifyAssemblyComponentScan,
        activeContainerTypeEnumId,
        autoComplete.notifyScanActivity,
        t
    ]);
    var handleBulkPackIntoContainer = function (_a) {
        var containerId = _a.containerId, scanId = _a.scanId;
        var target = { kind: 'real', containerId: containerId };
        requestContainerSwitch(target, function () {
            var _a;
            var prefillData = { scanId: scanId, quantity: 1 };
            (_a = bulkContainerModalRef.current) === null || _a === void 0 ? void 0 : _a.prefill(prefillData);
            setSelectedContainerRef(target);
            setBulkContainerModalVisible(true);
        });
    };
    var handleUnpackPackageItem = useCallback(function (assetIssuanceId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleUnpackItem(assetIssuanceId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [handleUnpackItem]);
    var handleUpdatePackageItemQuantity = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
                        return [2 /*return*/];
                    return [4 /*yield*/, handleUpdateQuantity({
                            shipmentPackageSeqId: selectedPackageSeqId,
                            productId: params.productId,
                            quantity: params.quantity,
                            orderId: params.orderId,
                            orderItemSeqId: params.orderItemSeqId
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [handleUpdateQuantity, selectedPackageRef, selectedPackageSeqId]);
    var handleDeleteSelectedPackage = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!selectedPackageRef)
                        return [2 /*return*/];
                    if (selectedPackageRef.kind === 'virtual') {
                        handleScannerDelete();
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handleDeletePackage(selectedPackageRef.seqId)];
                case 2:
                    _b.sent();
                    setSelectedPackageRef(null);
                    setIsCloseModalVisible(false);
                    setUpdatePackageModalVisible(false);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    message.error(t('Failed to delete package'));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [selectedPackageRef, handleScannerDelete, handleDeletePackage, t]);
    var handleResetSelectedPackage = useCallback(function () {
        if (!selectedPackageSeqId)
            return;
        void handleResetPackage(selectedPackageSeqId);
    }, [selectedPackageSeqId, handleResetPackage]);
    var handleDeleteSelectedPackageAction = useCallback(function () {
        void handleDeleteSelectedPackage();
    }, [handleDeleteSelectedPackage]);
    return (_jsxs("div", __assign({ className: 'flex h-full min-h-0 flex-col bg-gray-100 text-gray-800' }, { children: [_jsxs("header", __assign({ className: 'flex h-16 shrink-0 items-center justify-between border-b border-gray-200 bg-white px-4 shadow-sm sm:px-6' }, { children: [_jsxs("div", __assign({ className: 'flex items-center gap-2 sm:gap-3 pl-8' }, { children: [_jsxs("button", __assign({ onClick: handleBack, className: 'flex items-center text-gray-500 transition-colors hover:text-primary' }, { children: [_jsx(MdOutlineKeyboardBackspace, { style: { fontSize: '22px' } }, void 0), _jsx("span", __assign({ className: 'text-xs font-semibold sm:text-sm' }, { children: t('GO BACK') }), void 0)] }), void 0), _jsx("div", { className: 'mx-2 hidden h-6 w-px bg-gray-300 sm:block' }, void 0), _jsxs("h2", __assign({ className: 'text-sm font-bold text-gray-800 sm:text-lg' }, { children: [t('Pack Shipment'), " #", shipmentId] }), void 0), shipmentStatus && (_jsx("div", __assign({ className: 'hidden items-center gap-2 sm:flex' }, { children: _jsx(StatusBadge, { status: shipmentStatus, statusDescription: statusDescription }, void 0) }), void 0))] }), void 0), _jsxs("div", __assign({ className: 'flex items-center gap-3' }, { children: [_jsxs("span", __assign({ className: 'hidden text-xs text-gray-500 lg:block capitalize' }, { children: [t('Packer'), ": ", _jsx("strong", { children: packerName }, void 0)] }), void 0), _jsx("button", __assign({ onClick: function () {
                                    void handleRefreshShipment();
                                }, disabled: !shipmentId || isRefreshingShipment, className: 'flex items-center justify-center rounded-lg border border-gray-200 bg-white p-2 text-gray-500 leading-none transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60 sm:px-4', title: t('Reload Shipment') }, { children: _jsx(ReloadOutlined, { spin: isRefreshingShipment, style: { fontSize: '14px' } }, void 0) }), void 0), (kitComponentProducts || []).length > 0 && _jsx(AssemblyViewToggleButton, {}, void 0), _jsx(SoundToggleButton, {}, void 0), _jsx("button", __assign({ onClick: function () { return setPrinterModalVisible(true); }, className: "flex items-center gap-2 rounded-lg border px-3 py-2 transition-colors sm:px-4 " + (isConnectionActive
                                    ? 'border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100'
                                    : 'border-gray-200 bg-white text-gray-500 hover:bg-gray-50'), title: (isConnectionActive ? t('Printer Connected') : t('Printer Disconnected')) }, { children: _jsx(PrinterOutlined, { style: { fontSize: '16px' }, className: 'self-center' }, void 0) }), void 0)] }), void 0)] }), void 0), _jsx("main", __assign({ className: 'flex-1 overflow-hidden p-4' }, { children: _jsxs("div", __assign({ className: 'grid h-full min-h-0 grid-cols-12 gap-4' }, { children: [_jsx("section", __assign({ className: 'col-span-12 min-h-0 lg:col-span-3' }, { children: _jsx(LeftSidebar, { selectedPackageKey: selectedPackageKey, selectedContainerKey: selectedContainerKey, virtualPackages: virtualPackages, containerList: shipmentContainerList, containerLinkedPackageSeqIds: containerLinkedPackageSeqIds, onPackageSelect: handleSidebarPackageSelect, onContainerSelect: handleSidebarContainerSelect, onNewPackage: handleNewPackage, onNewContainer: function (containerTypeEnumId) {
                                    var type = containerTypeEnumId || 'CtPallet';
                                    if (type === 'CtCarton' && selectedContainerRef) {
                                        var selected = shipmentContainerList.find(function (c) { return c.containerId === selectedContainerRef.containerId; });
                                        if ((selected === null || selected === void 0 ? void 0 : selected.isRoot) && selected.containerTypeEnumId === 'CtPallet' && selected.statusId === ContainerStatus.Open) {
                                            void createContainerAndSelect({ containerTypeEnumId: 'CtCarton', parentContainerId: selected.containerId });
                                            return;
                                        }
                                    }
                                    requestContainerSwitch(null, function () {
                                        void createContainerAndSelect({ containerTypeEnumId: type });
                                    });
                                }, onBulkPackClick: function () { return setBulkPackModalVisible(true); }, onBulkContainerClick: function () { return setBulkContainerModalVisible(true); }, onBulkPack: function (containerId) {
                                    var target = { kind: 'real', containerId: containerId };
                                    requestContainerSwitch(target, function () {
                                        setSelectedContainerRef(target);
                                        setSelectedPackageRef(null);
                                        setBulkContainerModalVisible(true);
                                    });
                                }, onContainerClose: function (containerId) {
                                    // settle queued scans
                                    if (shipmentId)
                                        void flushScanQueueNow(shipmentId);
                                    setCloseContainerModalContainerId(containerId);
                                }, onContainerReopen: handleReopenContainer, onContainerDelete: function (containerId) {
                                    handleDeleteContainer(containerId);
                                    if ((selectedContainerRef === null || selectedContainerRef === void 0 ? void 0 : selectedContainerRef.kind) === 'real' && selectedContainerRef.containerId === containerId) {
                                        setSelectedContainerRef(null);
                                    }
                                }, onContainerReset: handleResetContainer, onDeleteVirtualPackage: function (tempId) {
                                    setVirtualPackages(function (prev) { return prev.filter(function (vp) { return vp.tempId !== tempId; }); });
                                    if ((selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) === 'virtual' && selectedPackageRef.tempId === tempId) {
                                        setSelectedPackageRef(null);
                                    }
                                }, showResetAllPackages: showResetAllPackages, showDeleteAllPackages: showDeleteAllPackages, isResetAllPackagesLoading: loading.resetAllPackages, isDeleteAllPackagesLoading: loading.deleteAllPackages, onResetAllPackages: handleResetAllPackagesAction, onDeleteAllPackages: handleDeleteAllPackagesAction, palletDisabled: !palletAllowed, palletDisabledTooltip: palletDisabledTooltip, cartonDisabled: cartonDisabled, cartonDisabledTooltip: t('This shipment has pallets — add cartons to a pallet instead.') }, void 0) }), void 0), _jsxs("section", __assign({ className: 'col-span-12 flex min-h-0 flex-col gap-4 lg:col-span-6' }, { children: [_jsxs("div", __assign({ className: 'flex-1 overflow-y-auto' }, { children: [(selectedContainerRef === null || selectedContainerRef === void 0 ? void 0 : selectedContainerRef.kind) === 'real' && (function () {
                                            var _a, _b;
                                            var selectedContainer = shipmentContainerList.find(function (c) { return c.containerId === selectedContainerRef.containerId; });
                                            if (selectedContainer) {
                                                var linkedSeqId_1 = selectedContainer.shipmentPackageSeqId;
                                                var linkedPkgInfo = linkedSeqId_1 ? getPackageInfo(linkedSeqId_1) : null;
                                                var linkedRouteSegment = linkedSeqId_1
                                                    ? packageRouteSegments.find(function (r) { return r.shipmentPackageSeqId === linkedSeqId_1; }) || null
                                                    : null;
                                                var hasGateway = Boolean((shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shippingGatewayConfigId) || ((_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.shippingGatewayConfigId));
                                                var routeSegSeqId_1 = (_b = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _b === void 0 ? void 0 : _b.shipmentRouteSegmentSeqId;
                                                return (_jsx(ContainerPane, { container: selectedContainer, allContainers: shipmentContainerList, shipmentItemDetailList: shipmentItemDetailList || [], productSkuUpcList: productSkuUpcList, containerSerialNumbersByContainerId: containerSerialNumbersByContainerId, isLoading: loading.containerScan, scanInputFocusSignal: scanInputFocusSignal, containerTypeMap: containerTypeMap, onSelectContainer: handlePaneContainerSelect, onScanToPack: handleScanToPack, onBulkPackIntoContainer: handleBulkPackIntoContainer, onContainerClose: function (containerId) {
                                                        // settle queued scans
                                                        if (shipmentId)
                                                            void flushScanQueueNow(shipmentId);
                                                        setCloseContainerModalContainerId(containerId);
                                                    }, onContainerReopen: handleReopenContainer, onContainerDelete: function (containerId) {
                                                        handleDeleteContainer(containerId);
                                                        setSelectedContainerRef(null);
                                                    }, onContainerReset: handleResetContainer, onContainerResetAndReturn: function (containerId) {
                                                        handleResetAndReturnContainer(containerId);
                                                        setSelectedContainerRef(null);
                                                    }, onAddChildContainer: function (parentContainerId) {
                                                        // FP-2671: create-action (not a switch into the parent) — see the sidebar handler above.
                                                        void createContainerAndSelect({ containerTypeEnumId: 'CtCarton', parentContainerId: parentContainerId });
                                                    }, onUpdateContainerType: handleUpdateContainerType, onUpdateContainer: function (containerId) { return setUpdateContainerModalContainerId(containerId); }, containerTypeList: containerTypeList.map(function (ct) { return ({ enumId: ct.enumId, description: ct.description }); }), boxTypes: boxTypes, 
                                                    // Package-level props for closed containers
                                                    linkedPackageInfo: linkedPkgInfo ? {
                                                        isClosed: linkedPkgInfo.isClosed,
                                                        shipmentBoxTypeId: linkedPkgInfo.shipmentBoxTypeId,
                                                        boxTypeDescription: linkedPkgInfo.boxTypeDescription,
                                                        weight: linkedPkgInfo.weight,
                                                        weightUomId: linkedPkgInfo.weightUomId,
                                                        trackingNumber: linkedPkgInfo.trackingNumber
                                                    } : null, productStoreId: productStoreId, canPrintMainLabel: Boolean(linkedSeqId_1 && routeSegSeqId_1 &&
                                                        !(linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.trackingCode) &&
                                                        (linkedPkgInfo === null || linkedPkgInfo === void 0 ? void 0 : linkedPkgInfo.shipmentBoxTypeId) &&
                                                        hasGateway), canPrintCarton: Boolean(productStoreId) && spsCartonLabel, canGetMainLabel: Boolean(linkedSeqId_1 &&
                                                        !(linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.trackingCode) &&
                                                        !(linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.gatewayLabelId) &&
                                                        (linkedPkgInfo === null || linkedPkgInfo === void 0 ? void 0 : linkedPkgInfo.shipmentBoxTypeId) &&
                                                        hasGateway), canDownloadMainLabel: Boolean(linkedSeqId_1 &&
                                                        ((linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.gatewayLabelId) || (linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.labelImage) || (linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.labelUrl))), onPrintPackingSlip: function (seqId) {
                                                        void printPackingSlip(seqId, { context: t('Packing slip') });
                                                    }, onPrintContainerInsert: function (seqId) {
                                                        void printContainerInsert(seqId, { context: t('Container insert') });
                                                    }, onPrintMainLabel: function (seqId) {
                                                        void printMainLabel(seqId, { context: t('Shipping label') });
                                                    }, onPrintCartonLabel: function (storeId) {
                                                        void printCartonLabel(storeId, { context: t('Carton label') });
                                                    }, onGetMainLabel: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                        return __generator(this, function (_a) {
                                                            switch (_a.label) {
                                                                case 0:
                                                                    if (!linkedSeqId_1 || !routeSegSeqId_1)
                                                                        return [2 /*return*/];
                                                                    return [4 /*yield*/, handleGetMainLabel({ shipmentPackageSeqId: linkedSeqId_1, shipmentRouteSegmentSeqId: routeSegSeqId_1 })];
                                                                case 1:
                                                                    _a.sent();
                                                                    return [2 /*return*/];
                                                            }
                                                        });
                                                    }); }, onDownloadMainLabel: function () {
                                                        if (!shipmentId || !linkedSeqId_1 || !routeSegSeqId_1)
                                                            return;
                                                        var url = process.env.REACT_APP_API_BASE_URL + "/rest/s1/handheld/pack/shipment/" + shipmentId + "/label?shipmentRouteSegmentSeqId=" + routeSegSeqId_1 + "&shipmentPackageSeqId=" + linkedSeqId_1;
                                                        window.open(url, '_blank');
                                                    }, onOpenReturnLabelModal: function () {
                                                        if (linkedSeqId_1)
                                                            setReturnLabelModalVisible(true);
                                                    }, onOpenUpdatePackage: function () {
                                                        if (linkedSeqId_1)
                                                            setUpdatePackageModalVisible(true);
                                                    }, onPrintContainerLicensePlate: function (containerIds) {
                                                        if (containerIds.length === 0)
                                                            return;
                                                        if (containerIds.length === 1) {
                                                            void printContainerLabel(containerIds[0], {
                                                                context: t('Container license plate')
                                                            });
                                                            return;
                                                        }
                                                        startBulkLabelPrint(containerIds);
                                                    }, palletShipment: palletAllowed }, void 0));
                                            }
                                            return null;
                                        })(), !selectedContainerRef && selectedPackageRef && (_jsx(PackingPane, { selectedPackageRef: selectedPackageRef, selectedPackageSeqId: selectedPackageSeqId, selectedVirtualPackage: selectedVirtualPackage, selectedPackageInfo: selectedPackageInfo, packageContentBySeqId: packageContentBySeqId, packageOrderItemsBySeqId: packageOrderItemsBySeqId, packageSerialNumbersBySeqId: packageSerialNumbersBySeqId, itemAssets: itemAssets, boxTypes: boxTypes, resettingPackage: resettingPackage, isPackingItemLoading: loading.packItem, isPackageContentActionLoading: loading.packItem || loading.shipment, isDeletingPackage: loading.deletePackage, scanInputFocusSignal: scanInputFocusSignal, spsCartonLabel: spsCartonLabel, productStoreId: productStoreId, onScanToPack: handleScanToPack, onAdvanceToClose: handleAdvanceToClose, onOpenUpdatePackage: handleOpenUpdatePackage, onResetSelectedPackage: handleResetSelectedPackage, onDeleteSelectedPackage: handleDeleteSelectedPackageAction, onPrintPackingSlip: function (seqId) {
                                                void printPackingSlip(seqId, { context: t('Packing slip') });
                                            }, onPrintMainLabel: function (seqId) {
                                                void printMainLabel(seqId, { context: t('Shipping label') });
                                            }, onPrintCartonLabel: function (storeId) {
                                                void printCartonLabel(storeId, { context: t('Carton label') });
                                            }, canGetMainLabel: canGetMainLabel, canDownloadMainLabel: canDownloadMainLabel, canRequestReturnLabel: canRequestReturnLabel, canUseReturnLabel: canUseReturnLabel, canRefundLabel: canRefundLabel, onGetMainLabel: handleGetMainLabelForSelectedPackage, onDownloadMainLabel: handleDownloadMainLabel, onOpenReturnLabelModal: handleOpenReturnLabelModal, onDownloadReturnLabel: handleDownloadReturnLabel, onPrintReturnLabel: handlePrintReturnLabel, onRefundLabel: handleRefundLabelForSelectedPackage, onUnpackPackageItem: handleUnpackPackageItem, onUpdatePackageItemQuantity: handleUpdatePackageItemQuantity }, void 0)), !selectedContainerRef && !selectedPackageRef && (_jsx(ScanToPackView, { isPackingItemLoading: loading.packItem, scanInputFocusSignal: scanInputFocusSignal, palletDisabled: !palletAllowed, palletDisabledTooltip: palletDisabledTooltip, cartonDisabled: cartonDisabled, cartonDisabledTooltip: 'Root cartons are not allowed when shipment has pallets.', onScanToPack: handleScanToPack }, void 0))] }), void 0), !selectedContainerRef && _jsx(ItemsInAssemblySection, { asCard: true }, void 0)] }), void 0), _jsxs("section", __assign({ className: 'col-span-12 flex min-h-0 flex-col gap-4 lg:col-span-3' }, { children: [_jsx("div", __assign({ className: 'min-h-0 flex-1' }, { children: _jsx(RightSidebar, { onShowAddressModal: function () { return setAddressModalVisible(true); } }, void 0) }), void 0), _jsx(PackingManagerActions, { onShowCancelModal: function () { return setCancelModalVisible(true); }, onShowPackCompleteModal: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!shipmentId) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, flushScanQueueNow(shipmentId)];
                                                case 1:
                                                    _a.sent();
                                                    _a.label = 2;
                                                case 2:
                                                    setPackCompleteModalVisible(true);
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); } }, void 0)] }), void 0)] }), void 0) }), void 0), _jsx(Modal, __assign({ open: !!pendingContainerSwitch, title: (pendingContainerSwitch === null || pendingContainerSwitch === void 0 ? void 0 : pendingContainerSwitch.reason) === 'other-packer'
                    ? t('Container being packed by someone else')
                    : t('Container still open'), onCancel: function () {
                    setPendingContainerSwitch(null);
                    // Modal close steals focus; defer the re-focus until after it releases.
                    setTimeout(function () { return setScanInputFocusSignal(function (prev) { return prev + 1; }); }, 0);
                }, okText: t('Switch anyway'), cancelText: (pendingContainerSwitch === null || pendingContainerSwitch === void 0 ? void 0 : pendingContainerSwitch.reason) === 'other-packer' ? t('Cancel') : t('Keep container open'), okButtonProps: { danger: true }, onOk: function () {
                    pendingContainerSwitch === null || pendingContainerSwitch === void 0 ? void 0 : pendingContainerSwitch.apply();
                    setPendingContainerSwitch(null);
                    // Modal close steals focus; defer the re-focus until after it releases.
                    setTimeout(function () { return setScanInputFocusSignal(function (prev) { return prev + 1; }); }, 0);
                } }, { children: _jsx("p", { children: (pendingContainerSwitch === null || pendingContainerSwitch === void 0 ? void 0 : pendingContainerSwitch.reason) === 'other-packer'
                        ? t('{{name}} is currently packing this container. Switching in may interrupt their work. Continue anyway?', { name: (pendingContainerSwitch === null || pendingContainerSwitch === void 0 ? void 0 : pendingContainerSwitch.packerName) || t('Another packer') })
                        : t('Please close this container before continuing.') }, void 0) }), void 0), _jsx(PrinterModal, { visible: printerModalVisible, onClose: function () { return setPrinterModalVisible(false); } }, void 0), _jsx(UpdateAddressModal, { visible: addressModalVisible, onClose: function () { return setAddressModalVisible(false); } }, void 0), _jsx(PackCompleteModal, { visible: packCompleteModalVisible, onClose: function () { return setPackCompleteModalVisible(false); } }, void 0), _jsx(AutoCompleteCountdownModal, { phase: autoComplete.phase, secondsLeft: autoComplete.secondsLeft, runningStep: autoComplete.runningStep, cartonLabel: autoComplete.cartonLabel, boxTypeDescription: autoComplete.boxTypeDescription, weightText: autoComplete.weightText, printErrorText: autoComplete.printErrorText, onCancel: autoComplete.cancel, onRetryPrint: autoComplete.retryPrint, onOpenLabel: autoComplete.openFailedLabel, onShipAnyway: autoComplete.shipAnyway, onDismissPrintFailure: autoComplete.dismissPrintFailure }, void 0), _jsx(UpdatePackageModal, { visible: !!(selectedPackageSeqId || activeContainerLinkedSeqId) && updatePackageModalVisible, packageSeqId: selectedPackageSeqId || activeContainerLinkedSeqId, linkedContainerTypeEnumId: !selectedPackageSeqId ? activeContainerTypeEnumId : null, onClose: function () { return setUpdatePackageModalVisible(false); } }, void 0), _jsx(ClosePackageModal, { visible: !!selectedPackageSeqId && isCloseModalVisible, packageSeqId: selectedPackageSeqId, onClose: function () { return setIsCloseModalVisible(false); }, onClosed: handlePackageClosed }, void 0), _jsx(UpdateContainerModal, { visible: !!updateContainerModalContainerId, container: updateContainerModalContainerId
                    ? (_c = shipmentContainerList.find(function (c) { return c.containerId === updateContainerModalContainerId; })) !== null && _c !== void 0 ? _c : null
                    : null, onClose: function () { return setUpdateContainerModalContainerId(null); }, onUpdated: function () { return setUpdateContainerModalContainerId(null); } }, void 0), _jsx(CloseContainerModal, { visible: !!closeContainerModalContainerId, container: closeContainerModalContainerId
                    ? (_d = shipmentContainerList.find(function (c) { return c.containerId === closeContainerModalContainerId; })) !== null && _d !== void 0 ? _d : null
                    : null, childContainers: (function () {
                    if (!closeContainerModalContainerId)
                        return [];
                    var parent = shipmentContainerList.find(function (c) { return c.containerId === closeContainerModalContainerId; });
                    if (!parent)
                        return [];
                    return parent.childContainerIdList
                        .map(function (id) { return shipmentContainerList.find(function (c) { return c.containerId === id; }); })
                        .filter(function (c) { return c != null; });
                })(), onClose: function () { return setCloseContainerModalContainerId(null); }, onClosed: function () {
                    setCloseContainerModalContainerId(null);
                    // De-select container to show scan to pack
                    setSelectedContainerRef(null);
                }, onAutoPrintContainerLabel: function (containerId) { return startBulkLabelPrint([containerId]); } }, void 0), _jsx(BulkPackModal, { ref: bulkPackModalRef, visible: bulkPackModalVisible, boxTypes: boxTypes, loading: loading.packItem || loading.closePackage, onClose: function () { return setBulkPackModalVisible(false); }, onSubmit: handleBulkPackSubmit }, void 0), _jsx(BulkContainerModal, { ref: bulkContainerModalRef, visible: bulkContainerModalVisible, loading: loading.containerScan, selectedContainerId: selectedRealContainerId, containerTypeList: containerTypeList.map(function (ct) { return ({ key: ct.enumId, value: ct.description }); }), boxTypes: boxTypes, onClose: function () { return setBulkContainerModalVisible(false); }, onSubmit: function (params) { return __awaiter(void 0, void 0, void 0, function () {
                    var autoPrintLabels, items, createParams, result, containerIds;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                autoPrintLabels = params.autoPrintLabels, items = params.items, createParams = __rest(params, ["autoPrintLabels", "items"]);
                                if (items.some(function (item) { return isSerializedScanId(item.scanId); })) {
                                    buzzScanError();
                                    pushScanError(t('Bulk packing is not allowed for serialized products'));
                                    // throw so the modal keeps the entered lines instead of closing on a rejected scan
                                    throw new Error('serialized product rejected');
                                }
                                return [4 /*yield*/, handleBulkCreateContainers(__assign(__assign({}, createParams), { scanItems: items.map(function (item) { return ({
                                            scanInput: item.scanId,
                                            quantityPerContainer: item.quantity
                                        }); }), weightUomId: 'WT_lb' }))
                                    // Auto select new root container (pallet)
                                ];
                            case 1:
                                result = _a.sent();
                                // Auto select new root container (pallet)
                                if (result === null || result === void 0 ? void 0 : result.packIntoContainerId) {
                                    if ((selectedContainerRef === null || selectedContainerRef === void 0 ? void 0 : selectedContainerRef.kind) === 'real' && selectedContainerRef.containerId === result.packIntoContainerId) {
                                        // Do not de-select
                                    }
                                    else {
                                        handleSidebarContainerSelect({ kind: 'real', containerId: result.packIntoContainerId });
                                    }
                                }
                                setBulkContainerModalVisible(false);
                                if (autoPrintLabels) {
                                    containerIds = [];
                                    if (createParams.createPackIntoContainer && (result === null || result === void 0 ? void 0 : result.packIntoContainerId)) {
                                        containerIds.push(result.packIntoContainerId);
                                    }
                                    if (result === null || result === void 0 ? void 0 : result.containerIdList)
                                        containerIds.push.apply(containerIds, result.containerIdList);
                                    startBulkLabelPrint(containerIds);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); } }, void 0), _jsx(SerialNumberModal, { visible: serialNumberModalVisible, onClose: function () {
                    setSerialNumberModalVisible(false);
                    setPendingSerializedPackRequest(null);
                    setPendingScanId(null);
                }, productId: pendingScanId, onSubmit: handleSerialNumberSubmit }, void 0), _jsx(ReturnLabelModal, { visible: !!selectedPackageSeqId && returnLabelModalVisible, onClose: function () { return setReturnLabelModalVisible(false); }, packageSeqId: selectedPackageSeqId }, void 0), shipmentId && (_jsx(CancelShipmentModal, { visible: cancelModalVisible, onClose: function () { return setCancelModalVisible(false); }, onConfirm: handleConfirmCancel, shipmentId: shipmentId }, void 0)), _jsx(ScanErrorStack, {}, void 0)] }), void 0));
};
export default PackingManager;
